function shopHandler() {
    return {
        currentPage: 'home',
        activeBrand: '',
        cartOpen: false,
        cart: [],
        calc: {
            kwp: 4,
            cons: 10,
            contract: 'fixed'
        },
        openBrand(brand) {
            this.activeBrand = brand;
            this.currentPage = 'brand';
            window.scrollTo(0, 0);
        },
        calculateResults() {
            const kwp = parseFloat(this.calc.kwp) || 0;
            const cons = parseFloat(this.calc.cons) || 0;
            const recommendedSize = Math.max(2, Math.round(kwp * 0.8));
            const annualSavings = Math.round(recommendedSize * 300 * 0.35);
            const payback = annualSavings > 0 ? (recommendedSize * 500 / annualSavings).toFixed(1) : 0;
            return { size: recommendedSize, savings: annualSavings, payback: payback };
        }
    }
}
